import Vue from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'

/*
* AG Grid Column Defs here
*/
export default Vue.extend({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      payrollClientColumn: {
        headerName: 'Client',
        field: 'client',
        colId: 'client',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        menuTabs: [],
        rowGroup: true,
        hide: true,
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('project.client.name_reports') : '(no name)', // Check if resource
        valueSetter: () => null
      },

      payrollProjectColumn: {
        headerName: 'Project',
        field: 'project',
        colId: 'project',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        menuTabs: [],
        rowGroup: true,
        hide: true,
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('project.name') : '(no name)', // Check if resource
        valueSetter: () => null
      },

      payrollStatusColumn: {
        headerName: 'Status',
        field: 'status',
        colId: 'status',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: [],
        rowGroup: true,
        aggFunc: 'count',
        hide: true,
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('status') : '(none)', // Check if resource
        valueSetter: () => null
      },

      payrollNumberColumn: {
        headerName: 'Number',
        field: 'number',
        colId: 'number',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => params.data && typeof params.data === 'object' ? params.data.get('number') : '(none)', // Check if resource
        valueSetter: () => null
      },

      payrollIdColumn: {
        headerName: 'ID',
        field: 'id',
        colId: 'id',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('id') : '(none)', // Check if resource
        valueSetter: () => null
      },

      payrollWeekEndingColumn: {
        headerName: 'WeekEnding',
        field: 'week_ending',
        colId: 'week_ending',
        maxWidth: 160,
        minWidth: 80,
        editable: false,
        sortable: true,
        menuTabs: [],
        rowGroup: true,
        hide: true,
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('project.client.pay_period_end_date') : 'UNKNOWN', // Check if resource
        valueSetter: () => null
      },

      payrollTimePostedColumn: {
        headerName: 'Time Posted',
        field: 'time_posted',
        colId: 'time_posted',
        maxWidth: 160,
        minWidth: 80,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('time_posted') : 'N/A', // Check if resource
        valueSetter: () => null
      },

      payrollCheckDateColumn: {
        headerName: 'Check Date',
        field: 'check_date',
        colId: 'check_date',
        maxWidth: 160,
        minWidth: 80,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('check_date') : '(none)', // Check if resource
        valueSetter: () => null
      },

      payrollLinkToPayrollColumn: {
        headerName: 'Link',
        field: 'link',
        colId: 'link',
        maxWidth: 200,
        minWidth: 160,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: ({ data }) => data && typeof data === 'object' ? data.get('number') : '(no name)', // Check if resource
        valueSetter: () => null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/AgGridPayrollColumns.js